function u(e, t) {
  for (var n = -1, l = e == null ? 0 : e.length; ++n < l; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_arraySome.js
// module id = 1462
// module chunks = 67